import { useBusinessModalContext as d } from "../BusinessModalContext.js";
import { useBusinessCount as B } from "./useBusinessCount.js";
import { useBusinessCountWithSelectionFilters as p } from "./useBusinessCountWithSelectionGroupIds.js";
import { SelectionType as u } from "../reducer/businessModal.types.js";
const m = ({
  selection: e,
  numberOfSelectedBusinessIds: s,
  numberOfUnselectedBusinessIds: t,
  count: o
}) => e?.type === u.ALL_WITH_FILTERS ? o + s - t : s, f = () => {
  const {
    preFilters: e
  } = d(), s = e?.selection?.type, {
    count: t = 0
  } = B(), {
    count: o = 0
  } = p(), n = e?.selectedBusinessIds?.length ?? 0, c = e?.unselectedBusinessIds?.length ?? 0, i = m({
    numberOfSelectedBusinessIds: n,
    numberOfUnselectedBusinessIds: c,
    selection: e?.selection,
    count: s === u.ALL_WITH_FILTERS ? o : t
  }), l = n > 0, r = c > 0;
  return {
    hasSelectedBusinesses: l,
    hasUnselectedBusinesses: r,
    totalBusinessesCount: t,
    totalSelectedBusinesses: i,
    selectedBusinessIdsCount: n,
    unselectedBusinessIdsCount: c
  };
};
export {
  f as useCountData
};
